import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole, getEcoles } from 'app/entities/ecole/ecole.reducer';
import { Menu } from 'antd';
import { NavLink as Link } from 'react-router-dom';
import SubMenu from 'antd/lib/menu/SubMenu';
import { Storage } from 'react-jhipster';
import { getEcoleActiveAnneeScolaire, getEcoleAnneeScolaire } from 'app/entities/annee-scolaire/annee-scolaire.reducer';

export const EcolesMenu = ({ isAuthenticated = false }, props: any) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEcoles({}));
  }, []);

  const ecoleList = useAppSelector(state => state.ecole.entities);

  const setcurrentecole = ecole => {
    Storage.session.set('currentEcole', ecole);
    Storage.session.set('currentAnneeScolaire', ecole.anneeScolaire);
    dispatch(getEcole(ecole.id));
    dispatch(getEcoleActiveAnneeScolaire(ecole.id));
  };

  return (
    <Menu theme="dark" id="ecole-menu" data-cy="ecoleMenu">
      <SubMenu title="Ecoles">
        {isAuthenticated && (
          <>
            {ecoleList.map((ecole, i) => (
              <Menu.Item key={i}>
                <a href={`/home/${ecole.id}/${ecole.anneeScolaire?.id}`} onClick={() => setcurrentecole(ecole)}>
                  {ecole.nom}
                </a>
              </Menu.Item>
            ))}
            <hr />
            <Menu.Item>
              <Link to="/ecole">Liste des écoles</Link>
            </Menu.Item>
            <Menu.Item>
              <Link to="/ecole/new">Créer une ecole</Link>
            </Menu.Item>
          </>
        )}
      </SubMenu>
    </Menu>
  );
};

export default EcolesMenu;
